import {t} from '../../../../../../services/i18n';

export const ONLY_AVAILABLE_DAYS_KEY = 'only_available';
export const ALL_DAYS_KEY = 'all';

export const getSwapDayFiltersConfig = () => [
    {
        key: 'availability',
        show: true,
        defaultValue: ONLY_AVAILABLE_DAYS_KEY,
        options: [
            {value: ONLY_AVAILABLE_DAYS_KEY, label: t('only-available-days')},
            {value: ALL_DAYS_KEY, label: t('all-days')},
        ],
        filterFunc: (day, value) => value !== ONLY_AVAILABLE_DAYS_KEY || day.spots_left > 0,
        style: {width: '180px', flexShrink: 0},
    },
];
